import React, { useState, useRef, useEffect } from "react";
import "./Explore_our_gallery.css";
import Common_heading from "../../common/common_heading/Common_heading";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

import { Gallerys } from "../../../utils/apis/gallery/Gallery";
import { IDS } from "../../../utils/common";

function Explore_our_gallery() {
  const navigate = useNavigate();
  const [showExplore, setShowExplore] = useState(false);
  const [gallery, setGallery] = useState([]);
  const swiperRef = useRef(null);

  // ✅ API CALL
  const getGallery = async () => {
    const res = await Gallerys();
    if (res?.success) {
      setGallery(res?.data || []);
    }
  };

  useEffect(() => {
    getGallery();
  }, []);

  return (
    <section className="Explore_our_gallery">
      <div className="custom_container">
        <div className="top_heading_holder">
          <Common_heading
            heading={"EXPLORE OUR GALLERY"}
            subHeading={
              "TAKE A CLOSER LOOK AT OUR PROJECTS, INSTALLATIONS, AND REAL-WORLD RESULTS."
            }
          />

          {/* Navigation */}
          <div className="custom_nav">
            <button
              className="nav_btn"
              onClick={() => swiperRef.current?.slidePrev()}
              type="button"
            >
              <FontAwesomeIcon icon={faAngleLeft} />
            </button>

            <button
              className="nav_btn right_angle_btn"
              onClick={() => swiperRef.current?.slideNext()}
              type="button"
            >
              <FontAwesomeIcon icon={faAngleRight} />
            </button>
          </div>
        </div>

        <div className="Explore_our_gallery_holder">
          <Swiper
            className="gallerySwiper"
            spaceBetween={15}
            slidesPerView={3.1}
            onSwiper={(swiper) => (swiperRef.current = swiper)}
            onSlideChange={(swiper) => {
              setShowExplore(swiper.isEnd);
            }}
            breakpoints={{
              320: { slidesPerView: 1.2 },
              480: { slidesPerView: 1.5 },
              640: { slidesPerView: 2.2 },
              768: { slidesPerView: 2.5 },
              1024: { slidesPerView: 3.1 },
              1280: { slidesPerView: 3.1 },
            }}
          >
            {gallery.map((item) => (
              <SwiperSlide key={item.id}>
                <div
                  className="img_holder"
                  onClick={() => navigate(`/gallery-inner/${item.id}`)}
                  style={{ cursor: "pointer" }}
                >
                  <img
                    src={IDS?.IMG_URL + item.image}
                    className="galler_img"
                    alt={item.name}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* Explore Button */}
          <div
            className={`explore_img_holder ${showExplore ? "show" : ""}`}
            onClick={() => navigate(`/gallery`)}
          >
            <div className="img_holder">
              <img
                src="/assets/images/home/explore_our_gallery/explore_btn.png"
                className="explore_img"
                alt="explore"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Explore_our_gallery;